const parseApplicationId = "si9WlzPAWZoKkK3YD0ki0NUCSnw0rqIF4xZguwUa";
const parseJavascriptId = "ekpQtVRHjU9eQRbAvjVFoSGAi9K01CUzgEehJCXW";

export { parseApplicationId, parseJavascriptId };
